/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-useless-fragment */
import { useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Input,
  ModalFooter,
  Button,
  Spinner,
  Flex,
} from "@chakra-ui/react";
import { Controller, useForm } from "react-hook-form";
import { useResetUserPassword } from "services/auth-api";

export const passwordExp = new RegExp(
  /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/
);

export default function PasswordResetModal({ show, onClose, user }) {
  const {
    mutate: changePassword,
    isPending: resettingPassword,
    isSuccess: passwordReset,
    error: errorResetting,
  } = useResetUserPassword();
  const {
    handleSubmit,
    setError,
    clearErrors,
    control,
    reset: resetForm,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: { email: "", newPassword: "", newPassword2: "" },
  });
  useEffect(() => {
    if (passwordReset) {
      onClose();
    }
    if (errorResetting) {
      setError("newPassword", {
        message:
          errorResetting.status === 400 && errorResetting.message
            ? errorResetting.message
            : "Can Not Reset Password",
      });
    }
    return () => {
      clearErrors();
      resetForm();
    };
  }, [passwordReset, errorResetting]);
  const onSubmit = (payload) => {
    const data = { email: user.email, newPassword: payload.newPassword };
    changePassword(data);
  };

  return (
    <>
      {show ? (
        <Modal isOpen={show} onClose={onClose} isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Reset Password</ModalHeader>
            <ModalCloseButton />
            <div
              className="form-container"
              style={{ width: "100%", margin: 0 }}
            >
              <form
                style={{ width: "100%", flexDirection: "column" }}
                onSubmit={handleSubmit(onSubmit)}
              >
                <ModalBody style={{ width: "100%" }}>
                  <FormControl style={{ width: "100%" }}>
                    <FormLabel>New Password</FormLabel>
                    <Controller
                      control={control}
                      name="newPassword"
                      rules={{
                        required: "New Password Is Required",
                        pattern: {
                          value:
                            /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/,
                          message:
                            "Invalid Password. Password should be more complex",
                        },
                      }}
                      render={({ field }) => (
                        <Input
                          value={field.value}
                          onChange={(e) => {
                            // console.log("field", field, e.target.value);
                            field.onChange(e.target.value);
                          }}
                        />
                      )}
                    />
                    <p className="error-message" style={{ color: "black" }}>
                      Must Include(1-9,A-Z,Special Characters(@#$%^&*))
                    </p>
                    {errors.newPassword ? (
                      <p className="error-message">
                        {errors.newPassword.message}
                      </p>
                    ) : (
                      <></>
                    )}
                  </FormControl>
                  <FormControl style={{ width: "100%", marginTop: "8px" }}>
                    <FormLabel>Confirm Password</FormLabel>
                    <Controller
                      control={control}
                      name="newPassword2"
                      rules={{
                        required: "Please Confirm Password",

                        validate: (value) => {
                          if (value !== watch("newPassword")) {
                            return "Password Not Matching";
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <Input
                          value={field.value}
                          onChange={(e) => {
                            // console.log("field", field, e.target.value);
                            field.onChange(e.target.value);
                          }}
                        />
                      )}
                    />
                    {errors.newPassword2 ? (
                      <p className="error-message">
                        {errors.newPassword2.message}
                      </p>
                    ) : (
                      <></>
                    )}
                  </FormControl>
                </ModalBody>

                <ModalFooter>
                  <Flex
                    flexDirection="row"
                    gap="10px"
                    as={Button}
                    type="submit"
                    isDisabled={resettingPassword}
                  >
                    {resettingPassword ? <Spinner size="sm" /> : <></>}
                    Update
                  </Flex>
                </ModalFooter>
              </form>
            </div>
          </ModalContent>
        </Modal>
      ) : (
        <></>
      )}
    </>
  );
}
